import { defineComponent } from 'vue';
export default defineComponent({
    name: 'PendingBankDeposit',
    setup() {
        return {};
    },
});
